// Text boxes that start one line tall and grow a line at a time as you type: every answer on
// the withdrawal page (its form lives in the page's content in Shopify admin), or any textarea
// marked data-auto-grow. One-line fields there (name, email, order no.) are swapped for such a
// box so a long answer wraps under itself instead of scrolling sideways; they keep their name,
// placeholder, autocomplete and required, Enter doesn't add a line, and the email is checked.
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const grow = (box: HTMLTextAreaElement) => {
  box.style.height = 'auto';
  box.style.height = `${box.scrollHeight}px`;
};

const toBox = (field: HTMLInputElement): HTMLTextAreaElement => {
  const box = document.createElement('textarea');
  ['name', 'placeholder', 'autocomplete', 'class', 'id'].forEach((attr) => {
    const value = field.getAttribute(attr);
    if (value !== null) box.setAttribute(attr, value);
  });
  box.required = field.required;
  box.value = field.value;
  box.dataset.singleLine = field.type;
  if (field.type === 'email') {
    box.setAttribute('inputmode', 'email');
    box.setAttribute('autocapitalize', 'off');
    box.spellcheck = false;
  }
  field.replaceWith(box);
  return box;
};

document.querySelectorAll<HTMLInputElement>('.wf-form input[type="text"], .wf-form input[type="email"]').forEach(toBox);

document.querySelectorAll<HTMLTextAreaElement>('.wf-form textarea, textarea[data-auto-grow]').forEach((box) => {
  const singleLine = box.dataset.singleLine;
  box.rows = 1;
  grow(box);

  box.addEventListener('input', () => {
    if (singleLine && /[\r\n]/.test(box.value)) box.value = box.value.replace(/[\r\n]+/g, ' ');
    if (singleLine === 'email') {
      const value = box.value.trim();
      box.setCustomValidity(value && !EMAIL.test(value) ? 'Please enter a valid email address.' : '');
    }
    grow(box);
  });

  if (singleLine) {
    box.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') event.preventDefault();
    });
  }
});

window.addEventListener('resize', () => {
  document.querySelectorAll<HTMLTextAreaElement>('.wf-form textarea, textarea[data-auto-grow]').forEach(grow);
});
